import { useAppSelector } from '../../redux';
import type TrailSurfaceTypeSegment from '../../types/TrailSurfaceTypeSegment';
import CurrentMarker from '../CurrentMarker';
import CustomRouteDistanceMarkers from '../DistanceMarkers/CustomRouteDistanceMarkers';
import DrawControlsProvider from './DrawControls/DrawControlsProvider';
import Segments from './Segments/Segments';
import SurfaceTypeSegments from './Segments/SurfaceTypeSegments';
import useMetadata from './useMetadata';

type CustomRouteProps = {
  drawingDisabled?: boolean;
  hideDirectionalArrows?: boolean;
  trackUserInteractions?: () => void;
  waypoints?: React.ReactNode;
  options?: {
    allowSpecificMarkerPlacementWhenLinesOverlap?: boolean;
    showPositionTooltip?: boolean;
  };
  surfaceTypeSegments?: TrailSurfaceTypeSegment[];
};

const CustomRoute = ({
  drawingDisabled,
  hideDirectionalArrows,
  trackUserInteractions,
  waypoints,
  options = {},
  surfaceTypeSegments
}: CustomRouteProps) => {
  const elevationCoordinates = useAppSelector(state => state.map.elevationCoordinates);
  const distanceMarkersEnabled = useAppSelector(state => state.map.dynamicStyleIds.includes('distanceMarkers'));

  useMetadata({ autoUpdate: true, trackUserInteractions });

  return (
    <DrawControlsProvider disabled={drawingDisabled} options={options}>
      {elevationCoordinates && <CurrentMarker latitude={elevationCoordinates.lat} longitude={elevationCoordinates.lng} />}
      {surfaceTypeSegments?.length ? (
        <SurfaceTypeSegments hideArrows={hideDirectionalArrows} surfaceTypeSegments={surfaceTypeSegments} />
      ) : (
        <Segments hideDirectionalArrows={hideDirectionalArrows} />
      )}
      {distanceMarkersEnabled && <CustomRouteDistanceMarkers />}
      {waypoints}
    </DrawControlsProvider>
  );
};

export default CustomRoute;
